import { onMounted, ref } from "vue";
import { queryUserList } from "@/api/organization";

export default function useUserList() {
  const userList = ref([]);

  const getUsers = () => {
    queryUserList(0).then((res) => {
      userList.value = res.data || [];
    });
  };

  onMounted(() => {
    getUsers();
  });
  return {
    userList,
  };
}
